import { useCallback, useRef } from 'react'

import {
	hide,
	setMessage,
	setOpened,
	setVariant,
	show,
	ToastVariant,
} from '#/app/store/toast-slice'
import { useAppDispatch, useAppSelector } from '#/app/store/store'

export type Variant = ToastVariant

const TOAST_DURATION_MS = 5000

export const useShowDataStore = () => {
	const dispatch = useAppDispatch()
	const { message, variant, isOpened } = useAppSelector((state) => state.toast)
	const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

	const clearHideTimeout = () => {
		if (hideTimeoutRef.current) {
			clearTimeout(hideTimeoutRef.current)
			hideTimeoutRef.current = null
		}
	}

	const showMessage = useCallback(
		(messageText: string = 'Произошла ошибка', messageVariant: Variant = 'error') => {
			clearHideTimeout()
			dispatch(show({ message: messageText, variant: messageVariant }))
			hideTimeoutRef.current = setTimeout(() => {
				dispatch(hide())
				hideTimeoutRef.current = null
			}, TOAST_DURATION_MS)
		},
		[dispatch]
	)

	return {
		message,
		variant,
		isOpened,
		setOpened: (value: boolean) => dispatch(setOpened(value)),
		setMessage: (value: string) => dispatch(setMessage(value)),
		setVariant: (value: Variant) => dispatch(setVariant(value)),
		showMessage,
	}
}
